module.exports = __webpack_public_path__ + "static/media/Leisure0cd11fb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/Leisure.svg
// module id = 1304
// module chunks = 0